import { useForm } from "@mantine/form";
import {
  TextInput,
  Text,
  Paper,
  Button,
  Divider,
  Stack,
  Anchor,
  Alert,
} from "@mantine/core";
import { IconCheck, IconAlertCircle } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { url } from "../misc/api";

export function ForgotPasswordScreen() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const form = useForm({
    initialValues: { email: "" },
    validate: {
      email: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
    },
  });

  const handleSubmit = async () => {
    setError(null);
    setLoading(true);
    try {
      const response = await fetch(url + "auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.values.email }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Something went wrong");
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "darkslategray",
        paddingTop: "10%",
        display: "flex",
        paddingBottom: 500,
      }}
    >
      <Paper
        radius="md"
        p="xl"
        withBorder
        style={{ width: 500, marginLeft: "auto", marginRight: "auto" }}
      >
        <Text size="lg" fw={500}>
          Reset Password
        </Text>
        <Divider
          label="Enter your email address"
          labelPosition="center"
          my="lg"
        />

        {success ? (
          <Alert icon={<IconCheck size="1rem" />} color="green" mb="md">
            If an account with that email exists, a password reset link has been
            sent. Please check your inbox.
          </Alert>
        ) : (
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
              <TextInput
                required
                label="Email"
                placeholder="hello@spilve.com"
                value={form.values.email}
                onChange={(event) =>
                  form.setFieldValue("email", event.currentTarget.value)
                }
                error={form.errors.email && "Invalid email"}
                radius="md"
              />

              {error && (
                <Alert icon={<IconAlertCircle size="1rem" />} color="red">
                  {error}
                </Alert>
              )}

              <Button type="submit" radius="xl" loading={loading}>
                Send Reset Link
              </Button>
            </Stack>
          </form>
        )}

        <Anchor
          component="button"
          type="button"
          color="dimmed"
          onClick={() => navigate("/login")}
          size="xs"
          style={{ marginTop: 20 }}
        >
          Back to Login
        </Anchor>
      </Paper>
    </div>
  );
}
